import { AccountTabs } from '~/constants/account'
import { PROMOTION_PLAN_TYPE, PROMOTION_SLUG_BY_TYPE } from '~/constants'
import type { PromotionBannerItem } from '~/utils/interface'
import { EVENT } from '~/configs/page-url'

const globImagesPromotionAccount: GlobImageI = import.meta.glob('~/assets/images/pages/account/*', { eager: true })
const iconImgUrlPromotionAccount = '/assets/images/pages/account'

export const getPromotionBanners = (newAgencyName = ''): PromotionBannerItem[] => [
  {
    packageId: 6,
    title: 'Tặng 100K',
    packageName: PROMOTION_SLUG_BY_TYPE.NEW_AGENCY,
    subTitle: `Khi cược tại ${newAgencyName}`,
    link: '/the-thao',
    slug: PROMOTION_SLUG_BY_TYPE.NEW_AGENCY,
    imgSrc: '/assets/images/pages/promotion/promotion-new-agency-slider.webp',
    thumbnailUrl: '/assets/images/pages/promotion/promotion-new-agency.webp',
    thumbnailUrlMb: '/assets/images/pages/promotion/promotion-new-agency-mb.webp',
    accountPageUrl: '',
    footer: {
      text: 'Thưởng 100K khi cược tại sảnh BONGK',
      button: { link: '/the-thao', text: 'Tham gia ngay' }
    }
  },
  {
    packageId: PROMOTION_PLAN_TYPE.WELCOME,
    title: 'Thưởng 100%',
    packageName: 'bonus-100',
    subTitle: 'Tiền nạp lần đầu',
    link: AccountTabs.DEPOSIT,
    slug: PROMOTION_SLUG_BY_TYPE.WELCOME,
    imgSrc: '/assets/images/pages/promotion/promotion-100-percent.png',
    thumbnailUrl: '/assets/images/pages/promotion/thumbnail-promotion-100-percentage.png',
    thumbnailUrlMb: '/assets/images/pages/promotion/thumbnail-thurong-100-mb.png',
    accountPageUrl: getImageURL(
      globImagesPromotionAccount,
      'promotion-100-percentage-refund',
      iconImgUrlPromotionAccount,
      'png'
    ),
    footer: { text: 'Thưởng nạp tiền lần đầu lên đến', highlight: '10,000,000 VNĐ' }
  },
  {
    packageId: PROMOTION_PLAN_TYPE.FIRST_50,
    title: 'Thưởng 50%',
    packageName: 'bonus-50',
    subTitle: 'Tiền nạp lần 2',
    link: AccountTabs.DEPOSIT,
    slug: PROMOTION_SLUG_BY_TYPE.FIRST_50,
    imgSrc: '/assets/images/pages/promotion/promotion-50-percent.png',
    thumbnailUrl: '/assets/images/pages/promotion/thumbnail-promotion-50-percentage.png',
    thumbnailUrlMb: '/assets/images/pages/promotion/thumbnail-thurong-50-mb.png',
    accountPageUrl: getImageURL(
      globImagesPromotionAccount,
      'promotion-50-percentage-refund',
      iconImgUrlPromotionAccount,
      'png'
    ),
    footer: { text: 'Thưởng nạp tiền lần 2 lên đến', highlight: '5,000,000 VNĐ' }
  },
  {
    packageId: PROMOTION_PLAN_TYPE.COMMISSION,
    packageName: 'cashback',
    badgeTitle: 'Hoàn Trả Trực Tuyến',
    title: 'Hoàn trả 1.5%',
    subTitle: 'Không giới hạn',
    link: AccountTabs.DEPOSIT,
    slug: PROMOTION_SLUG_BY_TYPE.COMMISSION,
    imgSrc: '/assets/images/pages/promotion/km-hoan-tra-15-percent.png',
    thumbnailUrl: '/assets/images/pages/promotion/thumbnail-km-hoan-tra-15.png',
    thumbnailUrlMb: '/assets/images/pages/promotion/thumbnail-thurong-hoan-tra-15-mb.png',
    accountPageUrl: getImageURL(globImagesPromotionAccount, 'km-hoan-tra-15-refund', iconImgUrlPromotionAccount, 'png'),
    footer: { text: 'Hoàn trả mỗi ngày lên đến', highlight: '1.5% tổng tiền đã cược' }
  }
]

export const eventBanner500K: PromotionBannerItem = {
  packageId: 6,
  title: 'Tặng 500K',
  packageName: PROMOTION_SLUG_BY_TYPE.EVENT_500K,
  subTitle: 'Cược không lo toang',
  link: '/test',
  slug: PROMOTION_SLUG_BY_TYPE.EVENT_500K,
  imgSrc: '/assets/images/pages/promotion/new-promotion-500k-slider.webp',
  thumbnailUrl: '/assets/images/pages/promotion/new-promotion-500k.webp',
  thumbnailUrlMb: '/assets/images/pages/promotion/new-promotion-500k-mb.webp',
  accountPageUrl: '',
  footer: {
    text: 'Nhận lại ngay 500K khi thua cược',
    button: { link: '/the-thao', text: 'Tham gia ngay' }
  }
}

export const eventBanner: PromotionBannerItem = {
  packageId: 5,
  title: 'Tặng 1 Tỷ Lì Xì',
  packageName: PROMOTION_SLUG_BY_TYPE.DUA_TOP_THE_THAO,
  subTitle: 'Đua Top tài phú',
  link: '/event',
  slug: PROMOTION_SLUG_BY_TYPE.DUA_TOP_THE_THAO,
  imgSrc: '',
  thumbnailUrl: '/assets/images/pages/promotion/thumbnail-promotion-dua-top.webp',
  thumbnailUrlMb: '/assets/images/pages/promotion/thumbnail-promotion-dua-top-mb.webp',
  accountPageUrl: '',
  footer: {
    text: 'Cược ngay, nhận thưởng khủng, đón đầu may mắn!',
    button: { link: '/event', text: 'Tham gia ngay' }
  }
}

export const eventPremierLeagueRanking: PromotionBannerItem = {
  isNavigateEventPage: true,
  packageId: PROMOTION_PLAN_TYPE.EVENT_PREMIER_LEAGUE_RANKING,
  title: 'Thưởng khủng',
  subTitle: 'Kèo Ngoại Hạng Anh',
  link: '',
  slug: EVENT.PREMIER_LEAGUE_RANKING,
  imgSrc: '/assets/images/pages/promotion/premier-league-ranking.webp',
  thumbnailUrl: '',
  thumbnailUrlMb: '',
  accountPageUrl: '',
  footer: {
    text: '',
    button: { link: '', text: '' }
  }
}

export const promotionsDepositMapping = [
  {
    id: PROMOTION_PLAN_TYPE.COMMISSION,
    title: 'Hoàn trả 1.5%',
    subTitle: 'Không giới hạn',
    imgSrc: getImageURL(globImagesPromotionAccount, 'promotion-15', iconImgUrlPromotionAccount, 'png')
  },
  {
    id: PROMOTION_PLAN_TYPE.WELCOME,
    title: 'Bonus 100%',
    subTitle: 'Nhận khuyến mãi lớn',
    imgSrc: getImageURL(globImagesPromotionAccount, 'promotion-100-percentage', iconImgUrlPromotionAccount, 'png')
  },
  {
    id: PROMOTION_PLAN_TYPE.FIRST_50,
    title: 'Bonus 50%',
    subTitle: 'Cho khách hàng mới',
    imgSrc: getImageURL(globImagesPromotionAccount, 'promotion-50-percentage', iconImgUrlPromotionAccount, 'png')
  }
]

export const eventHalloweenRanking: PromotionBannerItem = {
  isNavigateEventPage: true,
  packageId: PROMOTION_PLAN_TYPE.EVENT_HALLOWEEN_RANKING,
  title: 'Tặng lượt FREE',
  subTitle: 'Vòng quay ma quái',
  link: '',
  slug: EVENT.HALLOWEEN,
  imgSrc: '/assets/images/pages/promotion/halloween-ranking.webp',
  thumbnailUrl: '',
  thumbnailUrlMb: '',
  accountPageUrl: '',
  footer: {
    text: '',
    button: { link: '', text: '' }
  }
}
